import { Feature } from '../../components/feature';
import Button from '../../components/Button';
import { UserRound } from 'lucide-react';
import { MediaCard } from '../../AvatarWhatsapp/Whatsapp';
import Text from '../../components/Text';
import { Img } from 'components';
import WebinarSignUp from './WebinarSignUp';

const points = [
    { icon: <UserRound className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Grow Admissions", description: "Up to ₹2.5 Cr" },
    { icon: <UserRound className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Free AI Tools", description: "₹5 Lakh Value" },
    { icon: <UserRound className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Expert team", description: "20 AI Experts" },
    { icon: <UserRound className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Reach", description: "1 Lakh Parents" },
]


export default function Webinar() {
    return (
        <div className="mt-9">
            <Feature
                badge={"Exclusive webinar"}
                title={"Join the Exclusive Webinar for School Owners like You"}
                mainClasses='md:p-1'
                description={
                    <div className='space-y-8'>
                        <Text label={"Explore how smart schools use AI to save time, cut costs and grow faster. Hosted by SooMuch.AI — India’s #1 AI powered complete business ecosystem for schools."} />
                        <div className="grid grid-cols-2 gap-4">
                            {points?.map((item, index) => <MediaCard key={"Webinar" + index} {...item} cName={"border border-[#E2E8F1] rounded-lg p-1"} />)}
                        </div>
                        <div className='flex items-start gap-4'>
                            <Text label={"In collaboration with"} cName='font-semibold text-[black]' />
                            <Img
                                alt={"collaboration"}
                                src={`images/new-landing-page/collaborationWith.png`}
                                className="object-fit w-[50%]"
                            />
                        </div>
                        <div className="flex items-center gap-6 md:flex-col md:justify-center">
                            <Button label='Get My Webinar Link' type='gradient' />
                            <Button label="Learn More" type='outlined' />
                        </div>
                    </div>
                }
                cta={
                    <div className="p-4 border border-[#E2E8F1] rounded-lg">
                        <Text cName='text-xs' label={"“The Soomuch.ai Assistant has reduced our administrative workload by over 40%. Our team can now focus on what truly matters: our students. It’s been a game-changer for our entire ecosystem.”"} />
                        <div className="flex gap-2 mt-2">
                            <Text label={"-Ms. Aditi Mishra"} cName='font-bold text-xs' />
                            <Text label={"Principal, Soomuch High School"} cName='text-xs' />
                        </div>
                    </div>
                }
                rightSideElement={<WebinarSignUp />}
            />
        </div>
    );
}